module.exports = __webpack_public_path__ + "img/ljfl_banner.4da053cf.jpg";